import type { PerFileSettings, OutputFormat } from '@/lib/queue/store';

export interface ConversionInput {
  file: File;
  settings: PerFileSettings;
  originalDimensions?: { width: number; height: number };
}

export interface ConversionResult {
  blob: Blob;
  outName: string;
  outSize: number;
  outWidth: number;
  outHeight: number;
  outFormat: OutputFormat;
}

/** Third-argument options bag passed by the processor into convert(). */
export interface ConvertOptions {
  upscaleServices?: {
    isModelReady: () => boolean;
    runUpscale: (blob: Blob, scale: 2 | 4, onProgress?: (pct: number) => void) => Promise<Blob>;
  };
  onUpscaled?: (factor: 2 | 4) => void;
  onUpscaleStart?: () => void;
  onUpscaleEnd?: () => void;
}

export type ConverterFn = (
  input: ConversionInput,
  onProgress?: (pct: number) => void,
  options?: ConvertOptions,
) => Promise<ConversionResult>;

/** Thrown by a converter when the request cannot reasonably be fulfilled and
 *  should surface as a soft "cancelled" state with a friendly user-facing
 *  message instead of a stack-trace error. */
export class CancelledError extends Error {
  readonly isCancelled = true;
  constructor(message: string) {
    super(message);
    this.name = 'CancelledError';
  }
}
